import { render } from "./role.vue?vue&type=template&id=4f6b4488&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"

import "./role.vue?vue&type=style&index=0&id=4f6b4488&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f6b4488"

export default script